import {
  APPEARANCE_STORAGE_KEY,
  DEFAULT_APPEARANCE,
  parseAppearance,
  type Appearance,
} from './appearance';

export function readAppearance(storage: Pick<Storage, 'getItem'> | null): Appearance {
  if (!storage) {
    return { ...DEFAULT_APPEARANCE };
  }
  try {
    const raw = storage.getItem(APPEARANCE_STORAGE_KEY);
    if (!raw) {
      return { ...DEFAULT_APPEARANCE };
    }
    return parseAppearance(JSON.parse(raw) as unknown);
  } catch {
    return { ...DEFAULT_APPEARANCE };
  }
}

export function writeAppearance(
  storage: Pick<Storage, 'setItem'> | null,
  appearance: Appearance,
): void {
  if (!storage) {
    return;
  }
  try {
    const payload = parseAppearance(appearance);
    storage.setItem(APPEARANCE_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // The current choice still applies when storage is blocked.
  }
}
